import _ from 'lodash';
import {
  CUSTOMER_DETAILS_FETCHED,
  CUSTOMER_DETAILS_FETCHED_ERROR,
  CUSTOMER_DETAILS_FETCHING,
} from './';
import { getCustomerDetails } from '../api';
import { format as formatPhoneNumber } from '../utils/phone-number';
import setDeviceFromCustomerDetails from './set-device-from-customer-details';

export const mapConfigurableFieldsToSelectedDeviceState = (
  fields,
  groupConfigurableFields
) => {
  const mappedFields = {};
  groupConfigurableFields.forEach(f => {
    mappedFields[f.columnName] = fields[f.displayName.toLowerCase()];
  });
  return mappedFields;
};

export default function fetchCustomerDetails(msisdn, groupSlug = '') {
  return async (dispatch, getState) => {
    dispatch({ type: CUSTOMER_DETAILS_FETCHING });
    const {
      group: { configurableFields },
    } = getState();

    try {
      const customerDetails = await getCustomerDetails(msisdn, groupSlug);
      if (_.isEmpty(customerDetails)) {
        throw new Error('Device not found.');
      }

      const {
        allowSubmit,
        warrantyStatus,
        hasAppleCare,
        hasActiveProtectionPlan,
        clearMsisdn = msisdn,
      } = customerDetails;

      const assurantIneligibleRepair =
        !hasAppleCare && warrantyStatus === 'OW' && !allowSubmit;

      const phoneNumber = formatPhoneNumber(clearMsisdn);

      dispatch({
        type: CUSTOMER_DETAILS_FETCHED,
        allowSubmit,
        hasActiveProtectionPlan,
        assurantIneligibleRepair,
        phoneNumber,
        ...customerDetails,
        ...mapConfigurableFieldsToSelectedDeviceState(
          { ...customerDetails, clearMsisdn },
          configurableFields
        ),
      });
      dispatch(setDeviceFromCustomerDetails(groupSlug));
    } catch (error) {
      dispatch({ type: CUSTOMER_DETAILS_FETCHED_ERROR, error: error.message });
    }
  };
}
